export enum SAAS_SUBSCRIPTIONS_DURATIONS_MODE {
  MANUAL = 'M',
  PRE_DEFINED = 'PD',
}

export enum SAAS_SUBSCRIPTIONS_DURATIONS_TYPES {
  MONTHS = 'M',
  WEEKS = 'W',
  DAYS = 'D',
  FREE = 'F',
}

export enum SAAS_SUBSCRIPTION_CUSTOM_RULES {
  NO_OF_TEMPLATES = 'NT',
  NO_OF_DOCUMENTS = 'ND',
  NO_OF_USERS = 'NU',
}

export enum SAAS_SUBSCRIPTION_METHODS {
  PAYABLE = 'P',
  FREE_TRIAL = 'FT',
  FREE_FOREVER = 'FF',
}

export enum SAAS_SUBSCRIPTION_STATUS {
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',
  EXPIRED = 'EXPIRED',
  DELETED = 'DELETED',
}

export enum SAAS_SUBSCRIPTION_PAYMENT_TYPE {
  PER_SEAT = 'PS',
  DEFAULT = 'D',
  FREE = 'F',
}

export enum SAAS_SUBSCRIPTION_LIMITS_DATA_TYPES {
  STRING = 's',
  BOOLEAN = 'b',
  NUMBER = 'n',
  DATE = 'd',
  DROP_DOWN = 'dd',
}
